import { ResidentialService } from './../../../questionarie-signup/questionnaire-residential/residential.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { CloudinaryModule, CloudinaryConfiguration } from '@cloudinary/angular-5.x';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';


@Component({
  selector: 'app-residential',
  templateUrl: './residential.component.html',
  styleUrls: ['./residential.component.css']
})
export class ResidentialComponent implements OnInit, AfterViewInit {
  videoSrc;
  showHelp = false;

  constructor(private residentialService: ResidentialService,private meta: Meta,private router: Router) { }
  ngOnInit() {
    this.meta.updateTag({name: 'robots', content: 'noindex, nofollow'});
  //   if (window.location.hash && window.location.hash == '#_=_') {
  //     window.location.href = window.location.href.split('#_=_')[0];
  // }
  }
  closebootvideo() {
    $('#myModal iframe').attr('src', jQuery('#myModal iframe').attr('src'));
    }
    closeHelpModal() {
      $('#myModal iframe').attr('src', jQuery('#myModal iframe').attr('src'));
    }
  ngAfterViewInit(): void {
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
  }

  help() {
    this.showHelp = true;
    this.residentialService.setHelpFlag({flag: true});
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
  }
}
